// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessageFooter_main__BbOxA {
    position: absolute;
    right: 0;
    bottom: 19px;
}

.ChatMessageFooter_list__TPCNJ {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
}

.ChatMessageFooter_item__37YnG {
    margin-right: 12px;
}

.ChatMessageFooter_item__37YnG:last-child {
    margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ChatMessageFooter/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".main {\n    position: absolute;\n    right: 0;\n    bottom: 19px;\n}\n\n.list {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n}\n\n.item {\n    margin-right: 12px;\n}\n\n.item:last-child {\n    margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ChatMessageFooter_main__BbOxA`,
	"list": `ChatMessageFooter_list__TPCNJ`,
	"item": `ChatMessageFooter_item__37YnG`
};
export default ___CSS_LOADER_EXPORT___;
